// @ts-nocheck
/**
 * mapScreenManagement.ts
 * マップ画面管理（2画面/4画面/ドラッグ入替/レイヤー管理）
 * App.vue から切り出し
 */

import maplibregl from 'maplibre-gl'
import { closeAllPopups } from '@/js/popup'
import { osmBrightSources, osmBrightLayers } from '@/js/layers'
import { requestAddLayers } from '@/js/layerEngine/addLayersGate'

type VM = any

export async function btnClickMenu(vm: VM, mapName) {
  // FloatingWindow用に修正
  const windowId = 'menu-window-' + mapName
  const currentVisible = vm.$store.state.floatingWindows[windowId]
  if (currentVisible) {
    vm.$store.dispatch('hideFloatingWindow', windowId)
  } else {
    vm.$store.dispatch('showFloatingWindow', windowId)
  }
}

export function btnClickLayer(vm: VM, mapName) {
  // オンボーディング中の場合は完了させる
  const isOnboarding = vm.showOnboardingTooltip
  if (isOnboarding) {
    vm.handleOnboardingComplete()
  }

  setTimeout(() => {
    // ★レイヤーラベル補完処理（名前の復元）
    const groupLayerMap = Object.fromEntries(
      vm.$store.state.currentGroupLayers.map(layer => [`oh-userlayer-${layer.id}`, layer.name])
    )
    const layers = vm.$store.state.selectedLayers[mapName]
    for (const layer of layers) {
      if (!layer.label || layer.label === '') {
        const name = groupLayerMap[layer.id]
        if (name) {
          layer.label = name
        }
      }
    }
  }, 300)

  // FloatingWindow用に修正
  const windowId = 'layer-window-' + mapName
  const currentVisible = vm.$store.state.floatingWindows[windowId]

  // オンボーディング中は必ずウィンドウを開く
  if (isOnboarding) {
    vm.$store.dispatch('showFloatingWindow', windowId)
  } else if (currentVisible) {
    vm.$store.dispatch('hideFloatingWindow', windowId)
  } else {
    vm.$store.dispatch('showFloatingWindow', windowId)
  }
}

export function btnClickSplit(vm: VM) {
  if (vm.s_map2Flg) {
    // 1画面へ
    vm.s_map2Flg = false
    vm.mapSize.map01.width = '100%'
    vm.mapSize.map01.height = '100%'
  } else {
    // 2画面へ — map01の位置をs_map2Flg変更前に保存（連動モードのsyncで上書きされるため）
    const map01 = vm.$store.state.map01
    const savedState = map01 ? {
      center: map01.getCenter(),
      zoom: map01.getZoom(),
      bearing: map01.getBearing(),
      pitch: map01.getPitch()
    } : null
    if (window.innerWidth > 1000) {
      vm.mapSize.map01.width = '50%'
      vm.mapSize.map01.height = '100%'
    } else {
      vm.mapSize.map01.width = '100%'
      vm.mapSize.map01.height = '50%'
      vm.mapSize.map02.width = '100%'
      vm.mapSize.map02.height = '50%'
      vm.mapSize.map02.top = '50%'
    }
    vm.s_map2Flg = true
    vm.ensureMap02Layers()
    vm.syncMap02ToMap01(savedState)
    if (typeof closeAllPopups === 'function') closeAllPopups()
  }
  vm.$nextTick(() => {
    // 印刷モード中でない場合のみ、スケール表示を更新
    if (!vm.isRightDiv2) {
      vm.updateScaleDisplay(false)
    }
  })
}

// マップを表示すべきかどうか
export function shouldShowMap(vm: VM, mapName) {
  // 印刷モード時はprintMapに応じて表示制御（再レンダリング耐性）
  if (vm.s_isPrint) {
    if (vm.s_printMap === 'map01') return mapName === 'map01'
    if (vm.s_printMap === 'map02') return mapName === 'map02'
    if (vm.s_printMap === 'map03') return mapName === 'map01' || mapName === 'map02'
  }
  if (mapName === 'map01') return true
  if (mapName === 'map02') return vm.s_map2Flg || vm.is4ScreenMode
  if (mapName === 'map03' || mapName === 'map04') return vm.is4ScreenMode
  return false
}

// 4画面モード: ドラッグ開始
export function onMapDragStart(vm: VM, event, mapName) {
  vm.draggingMapName = mapName
  event.dataTransfer.effectAllowed = 'move'
  event.dataTransfer.setData('text/plain', mapName)
  // ドラッグ中のスタイル
  event.target.classList.add('dragging')
}

// 4画面モード: ドラッグオーバー（ドロップ先に入った時）
export function onMapDragEnter(vm: VM, event, mapName) {
  if (vm.draggingMapName && vm.draggingMapName !== mapName) {
    vm.dragOverMapName = mapName
    // ドロップ先のハイライト
    const targetEl = document.getElementById(mapName)
    if (targetEl) targetEl.classList.add('drag-over')
  }
}

// 4画面モード: ドラッグリーブ
export function onMapDragLeave(vm: VM, event) {
  // ドロップ先のハイライトを解除
  if (vm.dragOverMapName) {
    const targetEl = document.getElementById(vm.dragOverMapName)
    if (targetEl) targetEl.classList.remove('drag-over')
  }
  vm.dragOverMapName = null
}

// 4画面モード: ドロップ（位置入れ替え）
export function onMapDrop(vm: VM, event, targetMapName) {
  event.preventDefault()
  if (vm.draggingMapName && vm.draggingMapName !== targetMapName) {
    swapMapPositions(vm, vm.draggingMapName, targetMapName)
  }
  onMapDragEnd(vm)
}

// 4画面モード: ドラッグ終了
export function onMapDragEnd(vm: VM) {
  // ハイライト解除
  if (vm.dragOverMapName) {
    const targetEl = document.getElementById(vm.dragOverMapName)
    if (targetEl) targetEl.classList.remove('drag-over')
  }
  // ドラッグ中スタイル解除
  document.querySelectorAll('.map-drag-handle.dragging').forEach(el => {
    el.classList.remove('dragging')
  })
  vm.dragOverMapName = null
  // ツールチップ再表示防止のため少し遅延してからリセット
  setTimeout(() => {
    vm.draggingMapName = null
  }, 300)
}

// 4画面モード: マップ位置の入れ替え
export function swapMapPositions(vm: VM, mapA, mapB) {
  const positions = [...vm.$store.state.fourScreenPositions]
  const indexA = positions.indexOf(mapA)
  const indexB = positions.indexOf(mapB)
  if (indexA !== -1 && indexB !== -1) {
    // 位置を入れ替え
    positions[indexA] = mapB
    positions[indexB] = mapA
    vm.$store.state.fourScreenPositions = positions
    // マップをリサイズ
    vm.$nextTick(() => {
      ;['map01', 'map02', 'map03', 'map04'].forEach(name => {
        const map = vm.$store.state[name]
        if (map) {
          try { map.resize() } catch (_) {}
        }
      })
    })
  }
}

// map03, map04の初期化
export function initializeMap03And04(vm: VM, callback) {
  const map01 = vm.$store.state.map01
  if (!map01) {
    if (callback) callback()
    return
  }
  const center = map01.getCenter()
  const zoom = map01.getZoom()
  const bearing = map01.getBearing()
  const pitch = map01.getPitch()

  let pendingLoads = 0
  const checkAllLoaded = () => {
    pendingLoads--
    if (pendingLoads <= 0 && callback) {
      callback()
    }
  }

  // map03
  if (!vm.$store.state.map03) {
    pendingLoads++
    const map03 = new maplibregl.Map({
      container: 'map03',
      style: { version: 8, sources: {}, layers: [] },
      center: [center.lng, center.lat],
      zoom: zoom,
      bearing: bearing,
      pitch: pitch,
      maxPitch: 85,
      attributionControl: false,
    })
    vm.$store.state.map03 = map03
    map03.on('load', () => {
      checkAllLoaded()
    })
  }
  // map04
  if (!vm.$store.state.map04) {
    pendingLoads++
    const map04 = new maplibregl.Map({
      container: 'map04',
      style: { version: 8, sources: {}, layers: [] },
      center: [center.lng, center.lat],
      zoom: zoom,
      bearing: bearing,
      pitch: pitch,
      maxPitch: 85,
      attributionControl: false,
    })
    vm.$store.state.map04 = map04
    map04.on('load', () => {
      checkAllLoaded()
    })
  }

  // 既に両方初期化済みの場合はすぐにコールバック
  if (pendingLoads === 0 && callback) {
    callback()
  }
}

// map03, map04にデフォルトレイヤーをセット（空の時のみ）、または既存レイヤーを復帰
export function ensureMap03And04Layers(vm: VM) {
  // map03のレイヤーを確保
  const map03Layers = vm.$store.state.selectedLayers?.map03 || []
  if (map03Layers.length === 0) {
    ensureMapLayers(vm, 'map03')
  } else {
    applyExistingLayersToMap(vm, 'map03')
  }
  // map04のレイヤーを確保
  const map04Layers = vm.$store.state.selectedLayers?.map04 || []
  if (map04Layers.length === 0) {
    ensureMapLayers(vm, 'map04')
  } else {
    applyExistingLayersToMap(vm, 'map04')
  }
}

// 既存のselectedLayersをマップに適用する（4画面復帰時用）
export function applyExistingLayersToMap(vm: VM, mapName) {
  const map = vm.$store.state[mapName]
  if (!map) return

  const existingLayers = vm.$store.state.selectedLayers?.[mapName] || []
  if (existingLayers.length === 0) return

  const applyLayers = () => {

    existingLayers.slice().reverse().forEach(layer => {
      if (!layer.layers) return

      // ソースを追加
      if (layer.sources) {
        layer.sources.forEach(source => {
          if (!map.getSource(source.id)) {
            try {
              const sourceObj = source.getTiles
                ? { ...source.obj, tiles: source.getTiles() }
                : source.obj
              map.addSource(source.id, sourceObj)
            } catch (e) {
              console.warn(`[4Screen] ${mapName} ソース追加エラー:`, source.id, e)
            }
          }
        })
      }
      if (layer.source && typeof layer.source === 'object') {
        if (!map.getSource(layer.source.id)) {
          try {
            const sourceObj = layer.source.getTiles
              ? { ...layer.source.obj, tiles: layer.source.getTiles() }
              : layer.source.obj
            map.addSource(layer.source.id, sourceObj)
          } catch (e) {
            console.warn(`[4Screen] ${mapName} ソース追加エラー:`, layer.source.id, e)
          }
        }
      }

      // レイヤーを追加
      layer.layers.forEach(layerDef => {
        if (!map.getLayer(layerDef.id)) {
          try {
            map.addLayer(layerDef)
          } catch (e) {
            console.warn(`[4Screen] ${mapName} レイヤー追加エラー:`, layerDef.id, e)
          }
        }
      })
    })

  }

  // マップがロード済みかどうかで処理を分岐
  if (map.loaded()) {
    applyLayers()
  } else {
    map.once('load', applyLayers)
  }
}

// 指定されたマップにOSMベクターレイヤーをセット（空の時のみ）
export function ensureMapLayers(vm: VM, mapName) {
  const currentLayers = vm.$store.state.selectedLayers?.[mapName] || []
  if (currentLayers.length > 0) {
    return // 既にレイヤーがあればスキップ
  }
  // OSMベクターレイヤーを作成
  const osmLayer = {
    id: 'oh-vector-layer-osm-bright',
    label: 'OSMベクター',
    sources: osmBrightSources,
    layers: osmBrightLayers,
    opacity: 1,
    visibility: true,
    attribution: '© <a href="https://wiki.openstreetmap.org/wiki/Japan/OSMFJ_Tileserver" target="_blank">OpenStreetMap</a> contributors',
  }
  // レイヤー追加をリクエスト（マップ固有）
  requestAddLayers(vm.$store, mapName)
  // storeのselectedLayersを新しいオブジェクトとして更新（リアクティビティを発火）
  vm.$store.state.selectedLayers = {
    ...vm.$store.state.selectedLayers,
    [mapName]: [osmLayer]
  }
  // 直接マップにレイヤーを追加（Dialog-layerのwatcherに頼らない）
  const map = vm.$store.state[mapName]
  if (map) {
    const addLayersToMap = () => {
      // ソースを追加
      osmBrightSources.forEach(source => {
        if (!map.getSource(source.id)) {
          map.addSource(source.id, source.obj)
        }
      })
      // レイヤーを追加
      osmBrightLayers.forEach(layer => {
        if (!map.getLayer(layer.id)) {
          map.addLayer(layer)
        }
      })
    }
    // マップがロード済みかどうかで処理を分岐
    if (map.loaded()) {
      addLayersToMap()
    } else {
      map.once('load', addLayersToMap)
    }
  }
}

// ネイティブ4画面同期のセットアップ
export function setupNative4ScreenSync(vm: VM) {
  // 既にセットアップ済みの場合はスキップ（重複登録防止）
  if (vm._4screenSyncSetup) {
    return
  }
  const maps = ['map01', 'map02', 'map03', 'map04'].map(name => vm.$store.state[name]).filter(Boolean)
  if (maps.length < 4) {
    console.warn('[4Screen] 全てのマップが初期化されていません')
    return
  }
  // 同期用のハンドラ
  let isSyncing = false
  const syncMaps = (sourceMap) => {
    if (isSyncing) return
    isSyncing = true
    const center = sourceMap.getCenter()
    const zoom = sourceMap.getZoom()
    const bearing = sourceMap.getBearing()
    const pitch = sourceMap.getPitch()
    maps.forEach(map => {
      if (map !== sourceMap) {
        map.jumpTo({ center, zoom, bearing, pitch })
      }
    })
    isSyncing = false
  }
  // 各マップにmoveイベントを登録
  maps.forEach(map => {
    map.on('move', () => {
      // 連動モード && 4画面モードの時のみ同期
      if (vm.$store.state.is4ScreenMode && vm.$store.state.mapSyncMode) {
        syncMaps(map)
      }
    })
  })
  vm._4screenSyncSetup = true
}

// 4画面モード用のポインター同期を追加セットアップ
export function setup4ScreenPointerSync(vm: VM) {
  // 既にセットアップ済みの場合はスキップ（重複登録防止）
  if (vm._4screenPointerSyncSetup) {
    return
  }
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  if (isTouchDevice) return

  const hideAllPointers = () => {
    const pointerIds = ['pointer1', 'pointer2', 'pointer3', 'pointer4']
    pointerIds.forEach(id => {
      const el = document.getElementById(id)
      if (el) el.style.display = 'none'
    })
  }

  const updateOtherPointers = (sourceMapName, lngLat) => {
    const mapNames = ['map01', 'map02', 'map03', 'map04']
    mapNames.forEach((mapName, index) => {
      if (mapName === sourceMapName) return
      const map = vm.$store.state[mapName]
      const pointerId = `pointer${index + 1}`
      const pointerEl = document.getElementById(pointerId)
      if (!map || !pointerEl) return
      const projectedPoint = map.project(lngLat)
      pointerEl.style.left = `${projectedPoint.x}px`
      pointerEl.style.top = `${projectedPoint.y}px`
      pointerEl.style.display = 'block'
    })
  }

  const map03And04 = ['map03', 'map04']
  map03And04.forEach((mapName, idx) => {
    const map = vm.$store.state[mapName]
    if (!map) return
    const pointerIndex = idx + 3

    map.on('mousemove', (e) => {
      if (vm.s_isPrint || !vm.is4ScreenMode) {
        hideAllPointers()
        return
      }
      const ownPointer = document.getElementById(`pointer${pointerIndex}`)
      if (ownPointer) ownPointer.style.display = 'none'
      updateOtherPointers(mapName, e.lngLat)
    })

    map.on('mouseleave', () => {
      hideAllPointers()
    })
  })
  vm._4screenPointerSyncSetup = true
}

export function ensureMap02Layers(vm: VM) {
  const map02Layers = vm.$store.state.selectedLayers?.map02 || []
  if (map02Layers.length > 0) {
    return
  }
  // 初めて2画面にするときはOSMベクターレイヤー1枚をセット
  const osmLayer = {
    id: 'oh-vector-layer-osm-bright',
    label: 'OSMベクター',
    sources: osmBrightSources,
    layers: osmBrightLayers,
    opacity: 1,
    visibility: true,
    attribution: '© <a href="https://wiki.openstreetmap.org/wiki/Japan/OSMFJ_Tileserver" target="_blank">OpenStreetMap</a> contributors',
  }
  requestAddLayers(vm.$store, 'map02')
  // storeのselectedLayersを新しいオブジェクトとして更新
  vm.$store.state.selectedLayers = {
    ...vm.$store.state.selectedLayers,
    map02: [osmLayer]
  }
  // 直接map02にレイヤーを追加（Dialog-layerのwatcherに頼らない）
  const map02 = vm.$store.state.map02
  if (map02) {
    // ソースを追加
    osmBrightSources.forEach(source => {
      if (!map02.getSource(source.id)) {
        map02.addSource(source.id, source.obj)
      }
    })
    // レイヤーを追加
    osmBrightLayers.forEach(layer => {
      if (!map02.getLayer(layer.id)) {
        map02.addLayer(layer)
      }
    })
  }
}

// 2画面切替時: map02の位置・ズームをmap01に合わせる
export function syncMap02ToMap01(vm: VM, savedState) {
  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02
  if (!map02 || !savedState) return
  vm.$nextTick(() => {
    try { map02.resize() } catch (_) {}
    // map01も復元（syncハンドラに上書きされている可能性があるため）
    if (map01) map01.jumpTo(savedState)
    map02.jumpTo(savedState)
    // resize完了後に再度jumpTo（display:none→表示直後の保険）
    setTimeout(() => {
      try { map02.resize() } catch (_) {}
      if (map01) map01.jumpTo(savedState)
      map02.jumpTo(savedState)
    }, 100)
  })
}

// 4画面モード用：一番上のレイヤー名を取得
export function getTopLayerLabel(vm: VM, mapName) {
  const layers = vm.$store.state.selectedLayers?.[mapName]
  if (!layers || layers.length === 0) return ''
  return layers[0].label || ''
}

// スワイプ比較モード用マップスタイル
export function getMapStyle(vm: VM, mapName) {
  const baseStyle = { ...vm.mapSize[mapName] }
  // 印刷モード時: map02のposition・位置を制御
  if (vm.s_isPrint && mapName === 'map02') {
    if (vm.s_printMap === 'map02' || vm.s_printMap === 'map03') {
      baseStyle.position = 'relative'
      let dir = vm.titleDirection
      if (dir === 'vertical') dir = 'a4-vertical'
      if (dir === 'horizontal') dir = 'a4-horizontal'
      if (vm.s_printMap === 'map03' && (dir === 'a4-horizontal' || dir === 'a3-horizontal')) {
        baseStyle.position = 'absolute'
        baseStyle.top = '0px'
        baseStyle.right = '0px'
      }
    }
  }
  // ボトムシートモード時：map01を上半分に
  if (vm.bottomSheetActive && mapName === 'map01') {
    return {
      ...baseStyle,
      width: '100%',
      height: '50%',
      top: 0,
      left: 0
    }
  }
  // 4画面モード時は全てのマップにposition:absoluteを適用
  if (vm.is4ScreenMode) {
    baseStyle.position = 'absolute'
    const positions = vm.fourScreenPositions
    const posIndex = positions.indexOf(mapName)
    if (posIndex !== -1) {
      const posStyles = [
        { top: 0, left: 0 },           // 0: 左上
        { top: 0, left: '50%' },       // 1: 右上
        { top: '50%', left: 0 },       // 2: 左下
        { top: '50%', left: '50%' }    // 3: 右下
      ]
      Object.assign(baseStyle, posStyles[posIndex])
    }
  }
  if (vm.swipeMode && mapName === 'map02') {
    return {
      ...baseStyle,
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      right: 'auto',
      clipPath: `inset(0 0 0 ${vm.swipePosition}%)`,
      zIndex: 2
    }
  }
  if (vm.swipeMode && mapName === 'map01') {
    return {
      ...baseStyle,
      zIndex: 1
    }
  }
  return baseStyle
}
